import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'

class LegendsModal extends React.Component {
  isEmpty = (text) => {
    return text && text !== '' ? text : '-'
  }

  render() {
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'open') }
        toggle={ get(this.props, 'toggle') }
      >
        <HeaderForm toggle={ get(this.props, 'toggle') }>
          <HeadLabel>Legends</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form >
                <FormGroup>
                  <Container >
                    <LabelTextInfo>Approval Status</LabelTextInfo>
                    <Row >
                      <Circle color='#BBBBBB' />
                      <ColDataInfo>
                        Unsubmitted
                      </ColDataInfo>
                    </Row>
                    <Row >
                      <Circle color='#F0AD4E' />
                      <ColDataInfo>
                      Pending
                      </ColDataInfo>
                    </Row>
                    <Row >
                      <Circle color='#5CB85C' />
                      <ColDataInfo>
                      Approved
                      </ColDataInfo>
                    </Row>
                    <Row >
                      <Circle color='#D44B49' />
                      <ColDataInfo>
                      Rejected
                      </ColDataInfo>
                    </Row>
                    <LabelTextInfo>Timesheet Legends</LabelTextInfo>
                    <Row >
                      <Square color='#EBEBEB' />
                      <ColDataInfo>
                        Sat-Sun
                      </ColDataInfo>
                    </Row >
                    <Row >
                      <Square color='#7B7B7B' />
                      <ColDataInfo>
                      Public Holiday
                      </ColDataInfo>
                    </Row >
                    <Row >
                      <Square color='#222222' />
                      <ColDataInfo>
                      Full day leave
                      </ColDataInfo>
                    </Row >
                    <Row >
                      <Square color='#FBFF7A' />
                      <ColDataInfo>
                      Half day leave
                      </ColDataInfo>
                    </Row >
                    <Row >
                      <Square color='#0071BD' />
                      <ColDataInfo>
                      Compensate Work
                      </ColDataInfo>
                    </Row >
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter />
      </Modal>
    )
  }
}

export default LegendsModal

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const LabelTextInfo = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  margin-bottom: 1%;
`
const ColDataInfo = styled(Col)`
  font-family: 'Gotham' !important;
  font-size: 14px ;
`
const Circle = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 5px;
  margin-top: 5px;
`
const Square = styled.div`
  height: 20px;
  width: 20px;
  background-color: ${(props) => props.color};
  margin-left: 10px;
  margin-right: 5px;
  border: 1px solid black;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/legends-modal.js